'use strict';

import React, { Component } from 'react';
import { AppRegistry, View } from 'react-native';
import { bslInit } from 'base/interface';
import Monitor from 'base/utils/monitor/index';

import {
  BrowserRouter,
  // HashRouter,
  Switch,
} from 'react-router-dom';
import CommonBridge from 'common/CommonBridge';
import Cookie from 'common/Cookie';
import { ResettingDefaultSetting } from 'common/DefaultSetting';
import * as uuid from 'uuid';
import getMRoutes from './routes/MRoutes';

try {
  ResettingDefaultSetting();
} catch (e) {
  console.log('reSetting default font error:', e);
}
function getQueryString(t) {
  const e = new RegExp('(^|[?]|&)' + t + '=([^&]*)(&|$)', 'i');
  const c = window.location.search || window.location.hash;
  const i = c.substr(1).match(e);
  return i != null ? unescape(i[2]) : null;
}
try {
  // utm流转
  try {
    const url_g_utm = getQueryString('g_utm');
    const session_g_utm = window.sessionStorage.getItem('m_g_utm');
    if (url_g_utm || session_g_utm) {
      window.sessionStorage.setItem('m_g_utm', url_g_utm || session_g_utm);
    } else {
      const cookie_utm_json = Cookie.getCookie('_utm_data');
      const cookie_utm = cookie_utm_json ? JSON.parse(cookie_utm_json) : {};
      cookie_utm.mtm && window.sessionStorage.setItem('m_g_utm', cookie_utm.mtm);
    }
    const client_id = getQueryString('client_id');
    const masid = getQueryString('masid');
    if (client_id) {
      Cookie.setCookie('client_id', client_id, '.mi.com');
    }
    if (masid) {
      Cookie.setCookie('masid', masid, '.mi.com');
    }
  } catch (error) {}
} catch (e) {}
const Router = BrowserRouter;
// 设置游客id用于匿名购买和推荐
const xmuuid = Cookie.getCookie('xmuuid');
if (!xmuuid) {
  Cookie.setCookie('xmuuid', 'XMGUEST-' + uuid.v1().toUpperCase(), '.mi.com');
}
export default class YPContent extends Component {
  constructor(props) {
    super(props);
    bslInit();
  }

  componentWillMount() {
    if (CommonBridge.isWeiXin()) {
      const isSt = CommonBridge.isStaging();
      // WxConfig.setWxConfig();
      if ((!Cookie.getCookie('xm_open_id') || Cookie.getCookie('xm_open_id') === 'false') && !isSt) {
        const client_id = '180100041061';
        Cookie.setCookie('client_id', client_id, '.mi.com');
        location.href = `${location.protocol}//${
          location.host
        }/v1/wxauthorize/authorize?callback_url=${encodeURIComponent(location.href)}`;
      } else {
        console.log('MiotStore componentWillMount');
      }
    }
    // 初始化
    Monitor.init({
      projectId: 'trade_center_md7c47ja1aimmbvmajl',
      version: process.env.RELEASE || '未知版本',
    });
    // 设置环境
    CommonBridge.getNormalEnvStatus().then(code => {
      // 0-线上 1-测试 2-预发
      let env = 'production';
      if (code === 1) {
        env = 'staging';
      } else if (code === 2) {
        env = 'preview';
      }
      Monitor.setEnv(env);
    });
  }

  renderDevRouter() {
    return <Switch>{getMRoutes()}</Switch>;
  }

  render() {
    return (
      <Router>
        {/* <Provider store={store}> */}
        <View style={{ flex: 1, width: '100%' }}>{this.renderDevRouter()}</View>
        {/* </Provider> */}
      </Router>
    );
  }
}
AppRegistry.registerComponent('YPContent', () => YPContent);
AppRegistry.runApplication('YPContent', { rootTag: document.getElementById('mishop') });
